export const routeConfig = {
  meta: {
    title: '应收账款融资',
  },
  redirect: '/financing/search'
};
